import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { FiCheckCircle } from 'react-icons/fi';
import { FaWhatsapp } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import aboutImg from '../../assets/about.jpg';
import styles from './About.module.css';

const WHATSAPP = 'https://wa.me/16726676878?text=Hi%20Murat%2C%20I%20would%20like%20to%20book%20an%20oil%20change%20service.';

export default function About() {
  const { t } = useTranslation();
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.15 });

  const checks = [
    t('about.checks.oil'),
    t('about.checks.obd'),
    t('about.checks.brake'),
    t('about.checks.fluid'),
    t('about.checks.noDriveway'),
    t('about.checks.allModels'),
  ];

  return (
    <section id="about" className={styles.section} ref={ref}>
      <div className={styles.container}>
        <motion.div className={styles.imgCol}
          initial={{ opacity: 0, x: -40 }} animate={inView ? { opacity: 1, x: 0 } : {}}
          transition={{ duration: 0.7 }}>
          <div className={styles.imgWrap}>
            <img src={aboutImg} alt="Murat Bulum" className={styles.img} />
            <div className={styles.badge}>
              <span className={styles.badgeNum}>5+</span>
              <span className={styles.badgeLabel}>{t('about.yearsExp')}</span>
            </div>
          </div>
        </motion.div>

        <motion.div className={styles.textCol}
          initial={{ opacity: 0, x: 40 }} animate={inView ? { opacity: 1, x: 0 } : {}}
          transition={{ duration: 0.7, delay: 0.15 }}>
          <span className={styles.label}><span className={styles.labelLine}/> {t('about.label')}</span>
          <h2 className={styles.heading}>
            <span className={styles.accent}>{t('about.heading1')}</span><br />
            {t('about.heading2')}<br />{t('about.heading3')}
          </h2>
          <p className={styles.text}>{t('about.text')}</p>

          <ul className={styles.checklist}>
            {checks.map(c => (
              <li key={c} className={styles.checkItem}>
                <FiCheckCircle className={styles.checkIcon} size={17}/>
                <span>{c}</span>
              </li>
            ))}
          </ul>

          <div className={styles.ctas}>
            <a href={WHATSAPP} target="_blank" rel="noreferrer" className={styles.btnWa}>
              <FaWhatsapp size={18}/> {t('about.bookWhatsapp')}
            </a>
            <a href="https://www.fram.com/" target="_blank" rel="noreferrer" className={styles.btnParts}>
              {t('about.lookParts')}
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
